import * as _ from 'lodash';
import { fromJS } from 'immutable';

import * as actions from '../actions/firm';
import { fetchingState } from '@constants';

const initialState = fromJS({
  files: { data: [], state: null },
  firms: { data: [], state: null },
  firm: { data: {}, state: null },
  results: {
    data: [],
    state: null,
    filters: {},
    sortModel: [],
    filterModel: {},
  },
  parties: { data: [], state: null },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 25,
    rowsPerPageOptions: [5, 10, 25, 50],
  },
});

const firmReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_FIRMS_START: {
      return state.setIn(['firms', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_FIRM_START: {
      return state.setIn(['firm', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_FIRM_START: {
      return state.setIn(['firm', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_FIRM_START: {
      return state.setIn(['firm', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_FIRM_START: {
      return state.setIn(['firm', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_FIRM_FILES_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_FIRM_FILE_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_FIRM_FILE_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_FIRM_PARTIES_START: {
      return state.setIn(['parties', 'state'], fetchingState.FETCHING);
    }

    case actions.FETCH_FIRMS_SUCCESS: {
      return state
        .setIn(['firms', 'state'], fetchingState.LOADED)
        .setIn(['firms', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_FIRM_SUCCESS: {
      return state
        .setIn(['firm', 'state'], fetchingState.LOADED)
        .setIn(['firm', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.INSERT_FIRM_SUCCESS: {
      return state
        .setIn(['firm', 'state'], fetchingState.LOADED)
        .setIn(['firm', 'data'], fromJS(_.get(action, 'data.results[0]', {})))
        .setIn(
          ['firms', 'data'],
          fromJS([
            ...state.getIn(['firms', 'data']),
            _.get(action, 'data.results[0]'),
          ]),
        );
    }
    case actions.UPDATE_FIRM_SUCCESS: {
      return state
        .setIn(['firm', 'state'], fetchingState.LOADED)
        .setIn(['firm', 'data'], fromJS(_.get(action, 'data.results[0]', {})))
        .setIn(
          ['firms', 'data'],
          fromJS(
            state
              .getIn(['firms', 'data'])
              .toJS()
              .map(el =>
                el.firmID === _.get(action, 'data.results[0].firmID')
                  ? action.data.results[0]
                  : el,
              ),
          ),
        );
    }
    case actions.DELETE_FIRM_SUCCESS: {
      return state
        .setIn(['firm', 'state'], fetchingState.LOADED)
        .setIn(['firm', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.FETCH_FIRM_FILES_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.INSERT_FIRM_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results')))
        .setIn(['firm', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.DELETE_FIRM_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results')))
        .setIn(['firm', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.SET_CURRENT_FIRM: {
      return state.setIn(
        ['firm', 'data'],
        fromJS(_.get(action, 'payload', {})),
      );
    }
    case actions.FETCH_FIRM_PARTIES_SUCCESS: {
      return state
        .setIn(['parties', 'state'], fetchingState.LOADED)
        .setIn(['parties', 'data'], fromJS(_.get(action, 'data.results', [])));
    }

    case actions.SEARCH_START: {
      return state
        .setIn(['results', 'state'], fetchingState.FETCHING)
        .setIn(['results', 'filters'], fromJS(_.get(action, 'payload', {})))
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);
    }
    case actions.SEARCH_SUCCESS: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['pagination', 'count'],
          _.get(action, 'data.totalFirms.firmCount', 0),
        );
    }
    case actions.SEARCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_FIRM_PARTIES_ERROR: {
      return state.setIn(['parties', 'state'], fetchingState.ERROR);
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    case actions.CHANGE_SORT_MODEL: {
      return state.setIn(['results', 'sortModel'], fromJS(action.payload));
    }
    case actions.CHANGE_FILTER_MODEL: {
      return state.setIn(['results', 'filterModel'], fromJS(action.payload));
    }
    default: {
      return state;
    }
  }
};

export default firmReducer;
